import React from 'react';
import servicesImg from '../../Assets/images/ServiceImage.jpeg';
// import SendContact from './SendContact'
import worldIcon from '../../Assets/images/worldIcon.png';
import PenEditIcon from '../../Assets/images/penEditIcon.png';
import DocIcon from '../../Assets/images/DocIcon.png';
import IdeaIcon from '../../Assets/images/IdeaIcon.png';
import BostIcon from '../../Assets/images/BostIcon.png';
import PSIcon from '../../Assets/images/PSIcon.png';
import DepositeIcon from '../../Assets/images/DepositeIcon.png';
import borrowIcon from '../../Assets/images/borrowIcon.png';
import Contact from '../Contact/Contact';
import { useNavigate } from 'react-router-dom';
import Footer from '../Footer/Footer';
const Services = () => {
    const navigate = useNavigate();
    const handleLoginClick = () => navigate('/login');
  const services = [
    // <FaChartLine size={40} className="text-green-500" />use icon instead of image
    {
      id: 1,
      icon: <img src={PenEditIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'LC Confirmation',
      text: ' Secures exporters by eliminating risks.',
    },
    {
      id: 2,
      icon: <img src={worldIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'UPAS LC Financing',
      text: 'Immediate payment, buyers’ deferred payment.',
    },
    {
      id: 3,
      icon: <img src={BostIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'Structured Import Financing',
      text: 'Custom finance for complex imports.',
    },
    {
      id: 4,
      icon: <img src={DocIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'Export Financing',
      text: 'Converts receivables to cash for exporters.',
    },
    {
      id: 5,
      icon: <img src={IdeaIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'RMG Working Capital',
      text: 'Competitive financing for RMG exporters.',
    },
    {
      id: 6,
      icon: <img src={PSIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'Easy Export to BD',
      text: ' Efficient export collection for Bangladesh.',
    },
    {
      id: 7,
      icon: <img src={DepositeIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'OBU Borrowing',
      text: 'Foreign currency loans for BD banks.',
    },
    {
      id: 8,
      icon: <img src={borrowIcon} alt="Logo" className="md:h-14 h-12 " />,
      title: 'OBU Deposit',
      text: 'Helps BD banks secure FCY deposits.',
    },
  ];
  return (
    <>
      <div id="services" className="w-full bg-white mt-20">
        <div className="container mx-auto md:px-0 px-6 lg:py-24 py-20 flex flex-col lg:flex-row items-center justify-between 2xl:gap-40">
          {/* Left Section: Text and Button */}
          <div className="text-center lg:text-left lg:w-1/2 mb-4 md:ml-16 lg:mb-0">
            <h1 className="text-2xl 2xl:text-6xl md:text-4xl  text-gray-800 md:mb-12 md:-mt-16 mb-3 heading">
              Comprehensive Loan Solutions Tailored to Your Needs.
            </h1>
            <p className="text-gray-600 md:text-sm text-xs 2xl:mb-10 md:mb-6 mb-4 paragraph">
              Comprehensive Loan Solutions Tailored to Your Needs. Explore our
              range of services designed to simplify your borrowing experience.
              From easy application processes to personalized loan options, we
              ensure a seamless journey from start to finish.
            </p>
            <button
              className=" text-headerBtn px-3 md:px-6 md:py-3 py-1 rounded-3xl border-2 border-headerBtn hover:bg-headerBtn hover:text-gray-50 text-sm md:text-sm md:mb-0 mb-10 heading"
              onClick={handleLoginClick}
            >
              Apply For UPAS/LC
            </button>
          </div>

          {/* Right Section: Image */}
          <div className="flex justify-end items-end">
            <img
              src={servicesImg}
              alt="ContactUsImg"
              className="w-full 2xl:w-full md:w-4/5 h-auto"
            />
          </div>
        </div>

        {/* our services */}
        <div className="bg-AboutUsBg">
          <div className="container mx-auto 2xl:px-16 md:px-16 px-4 py-16 ">
            <div className="text-center">
              <h2 className="md:text-3xl text-2xl font-bold  text-gray-800 mb-2 heading">
                Our Services
              </h2>
              <p className="md:mb-12 mb-8 md:text-sm text-sm">
                Explore the range of loan options and financial solutions we
                offer to meet your needs.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {services.map(services => (
                <div
                  key={services.id}
                  className="bg-white md:p-4 p-6 rounded-xl shadow-orange-200 hover:shadow-xl hover:bg-gray-100 transition-shadow duration-300"
                >
                  <div className="flex gap-4">
                    <div>{services.icon}</div>

                    <div className="">
                      <h3 className="md:text-lg text-lg font-semibold text-gray-800 mb-2">
                        {services.title}
                      </h3>
                      <p className="text-gray-600 text-xs md:text-xs">
                        {services.text}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Contact />
    </>
  );
};

export default Services;